type MemberCategoryOption = {
  id: string;
  name: string;
};

export const sortMemberCategoryOptions = <
  TCategory extends MemberCategoryOption
>(
  categories: TCategory[]
): TCategory[] =>
  [...categories].sort(
    (left, right) =>
      left.name.localeCompare(right.name, "en", { sensitivity: "base" }) ||
      left.id.localeCompare(right.id)
  );
